module.exports = __webpack_public_path__ + "static/1-e5632ea074c39e70deb7b2d300a6fd55.jpg";